import { invoke } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { showMessage } from '../../actions/show-message';
import RootBase from '../root-base';
import { createNavigation } from '../../services/create-navigation';
import { getCommunitiesContext } from '../../selectors/communities-context-selectors';
import getRoutes from '../../get-routes';

class Root extends Component {
  constructor(props) {
    super(props);

    const state = this.props.store.getState();
    const context = getCommunitiesContext(state);

    this.state = {
      navigation: createNavigation(props.store),
      context,
    };
  }

  componentDidMount() {
    this.unregisterListener = this.props.store.subscribe(this.contextListener);
  }

  componentWillUnmount() {
    invoke(this, 'unregisterListener');
  }

  contextListener = () => {
    const state = this.props.store.getState();
    const context = getCommunitiesContext(state);

    if (context !== this.state.context) {
      this.setState({
        navigation: createNavigation(this.props.store),
        context,
      });
    }
  }

  render() {
    const { store, history } = this.props;
    const { navigation } = this.state;
    const actions = bindActionCreators({ showMessage }, store.dispatch);

    return (
      <RootBase store={store} history={history} environment={{ showMessage: actions.showMessage, navigation }}>
        {getRoutes()}
      </RootBase>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default Root;



// WEBPACK FOOTER //
// ./app/containers/root/root.js